// convert UTC datetime to local datetime
const ConvertUTCToLocalDateTime = (date) => {
  let newDate = date.at(-1) === "Z" ? date : date + "Z";
    var utcDate = new Date(newDate).toLocaleString(navigator.language, 
      {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    var formattedDate = utcDate.replace(",", " ");
    return formattedDate;
  }

  // convert UTC datetime to local date 
const ConvertUTCToLocalDate = (date) => {
  var formattedDate = ConvertUTCToLocalDateTime(date).split(' ')[0];
  return formattedDate;
}

export {ConvertUTCToLocalDateTime, ConvertUTCToLocalDate};


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/UTCToLocalDate.js